import { gql } from '@apollo/client';

export const GQL_INSERT_CERTIFICATE = gql`
  mutation insertCertificateWithHistory($input: CertificateInput) {
    insertCertificateWithHistory(input: $input) {
      id
      layout
      name
      issuerName
      templateImageId
      isDisabled
      templateImage {
        id
        url
        title
      }
    }
  }
`;

export const GQL_EDIT_CERTIFICATE = gql`
  mutation editCertificateWithHistory($input: CertificateInput) {
    editCertificateWithHistory(input: $input) {
      id
      layout
      name
      issuerName
      templateImageId
      isDisabled
      templateImage {
        id
        url
        title
      }
    }
  }
`;

export const GQL_SEND_CERTIFICATE = gql`
  mutation sendMailCertificate($input: CertificateInput!) {
    sendMailCertificate(input: $input) {
      id
      name
      status
      message
    }
  }
`;
